import React from 'react';
import { useNavigate } from 'react-router-dom';

const AcceptableUsePolicy = () => {
  const navigate = useNavigate();
  
  return (
    <div>
      {/* Back to Home Button */}
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        padding: '20px 20px 0 20px'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: '#2563eb',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            fontSize: '0.95rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          onMouseOver={(e) => e.target.style.background = '#1d4ed8'}
          onMouseOut={(e) => e.target.style.background = '#2563eb'}
        >
          <span>←</span> Back to Home
        </button>
      </div>
      
      <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>Acceptable Use Policy</h1>
      <p style={{ color: '#666', marginBottom: '40px' }}><strong>Effective Date:</strong> January 1, 2025</p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Introduction</h2>
        <p>This Acceptable Use Policy ("AUP") governs your use of SmartPDF Tools ("the Service") provided by SmartPDF Tools ("we," "us," or "our"). By using our Service, you agree to comply with this AUP. Violation of this policy may result in suspension or termination of your account without prior notice.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Permitted Use</h2>
        <p>SmartPDF Tools is designed for legitimate PDF processing needs. You may use our Service to:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}>Merge multiple PDF documents into a single file</li>
          <li style={{ marginBottom: '10px' }}>Split PDF documents into separate files</li>
          <li style={{ marginBottom: '10px' }}>Compress PDF files to reduce file size</li>
          <li style={{ marginBottom: '10px' }}>Convert PDFs to images (JPG) and other supported formats</li>
          <li style={{ marginBottom: '10px' }}>Convert Word documents to PDF and vice versa</li>
          <li style={{ marginBottom: '10px' }}>Convert images to PDF format</li>
          <li style={{ marginBottom: '10px' }}>Process documents for personal, educational, or business purposes</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Prohibited Activities</h2>
        <p>You agree NOT to use SmartPDF Tools for any of the following purposes:</p>
        
        <h3 style={{ fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px', color: '#1e40af' }}>1. Illegal Activities</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Uploading, processing, or distributing content that violates any applicable laws or regulations</li>
          <li style={{ marginBottom: '8px' }}>Processing documents related to illegal activities, fraud, or deception</li>
          <li style={{ marginBottom: '8px' }}>Circumventing digital rights management (DRM) or copyright protection mechanisms</li>
          <li style={{ marginBottom: '8px' }}>Money laundering, terrorist financing, or other criminal activities</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px', color: '#1e40af' }}>2. Intellectual Property Violations</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Uploading or processing copyrighted material without proper authorization</li>
          <li style={{ marginBottom: '8px' }}>Infringing on trademarks, patents, or other intellectual property rights</li>
          <li style={{ marginBottom: '8px' }}>Distributing pirated content or unauthorized copies of protected works</li>
          <li style={{ marginBottom: '8px' }}>Processing documents obtained through unauthorized access or theft</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px', color: '#1e40af' }}>3. Harmful or Malicious Content</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Uploading files containing viruses, malware, trojans, or other malicious code</li>
          <li style={{ marginBottom: '8px' }}>Attempting to compromise the security or integrity of our systems</li>
          <li style={{ marginBottom: '8px' }}>Processing content that is defamatory, harassing, threatening, or abusive</li>
          <li style={{ marginBottom: '8px' }}>Distributing spam, phishing attempts, or other unsolicited communications</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px', color: '#1e40af' }}>4. Inappropriate Content</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Uploading, processing, or distributing child sexual abuse material (CSAM)</li>
          <li style={{ marginBottom: '8px' }}>Processing content depicting or promoting violence, terrorism, or hate speech</li>
          <li style={{ marginBottom: '8px' }}>Adult content or pornography (we reserve the right to refuse service)</li>
          <li style={{ marginBottom: '8px' }}>Content that exploits or harms minors in any way</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px', color: '#1e40af' }}>5. System Abuse</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Automated scraping, crawling, or harvesting of data from our Service</li>
          <li style={{ marginBottom: '8px' }}>Using bots, scripts, or automated tools to access the Service without authorization</li>
          <li style={{ marginBottom: '8px' }}>Attempting to reverse engineer, decompile, or disassemble any part of our Service</li>
          <li style={{ marginBottom: '8px' }}>Overloading or attempting to disrupt our servers or network infrastructure</li>
          <li style={{ marginBottom: '8px' }}>Circumventing rate limits, usage restrictions, or security measures</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px', color: '#1e40af' }}>6. Account Misuse</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Creating multiple accounts to evade usage limits or circumvent bans</li>
          <li style={{ marginBottom: '8px' }}>Sharing account credentials or allowing unauthorized access to your account</li>
          <li style={{ marginBottom: '8px' }}>Impersonating another person or entity</li>
          <li style={{ marginBottom: '8px' }}>Providing false or misleading information during registration</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px', color: '#1e40af' }}>7. Commercial Restrictions</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Reselling or redistributing our Service without written permission</li>
          <li style={{ marginBottom: '8px' }}>Using the Service to compete with SmartPDF Tools or develop a similar product</li>
          <li style={{ marginBottom: '8px' }}>Incorporating our Service into another product or service without authorization</li>
          <li style={{ marginBottom: '8px' }}>Excessive commercial use that impacts service availability for other users (unless on an appropriate paid plan)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Usage Limits and Fair Use</h2>
        <p>To ensure fair access for all users, we implement the following usage guidelines:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}><strong>Free Plan:</strong> Limited to 3 file operations per day</li>
          <li style={{ marginBottom: '10px' }}><strong>Paid Plans:</strong> Unlimited operations, subject to fair use policy</li>
          <li style={{ marginBottom: '10px' }}><strong>File Size Limits:</strong> Individual files must not exceed reasonable size limits (typically 100MB per file)</li>
          <li style={{ marginBottom: '10px' }}><strong>Processing Time:</strong> Excessive processing times may be subject to timeout</li>
        </ul>
        <p style={{ marginTop: '15px' }}>We reserve the right to throttle or temporarily suspend accounts that exhibit patterns of abuse or excessive usage that impacts service quality for other users.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Reporting Violations</h2>
        <p>If you become aware of any violations of this Acceptable Use Policy, please report them immediately to:</p>
        <div style={{ background: '#f3f4f6', padding: '15px', borderRadius: '8px', marginTop: '15px' }}>
          <p style={{ margin: '5px 0' }}><strong>Email:</strong> <a href="mailto:support@smrtpdftools.com" style={{ color: "#2563eb" }}>support@smrtpdftools.com</a></p>
          <p style={{ margin: '5px 0' }}><strong>Subject Line:</strong> "AUP Violation Report"</p>
        </div>
        <p style={{ marginTop: '15px' }}>We will investigate all reported violations promptly and take appropriate action.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Enforcement and Consequences</h2>
        <p>Violations of this Acceptable Use Policy may result in one or more of the following actions:</p>
        <ol style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}><strong>Warning:</strong> First-time minor violations may result in a warning</li>
          <li style={{ marginBottom: '10px' }}><strong>Temporary Suspension:</strong> Access to your account may be temporarily suspended</li>
          <li style={{ marginBottom: '10px' }}><strong>Permanent Termination:</strong> Your account may be permanently terminated without refund</li>
          <li style={{ marginBottom: '10px' }}><strong>Legal Action:</strong> We may report serious violations to law enforcement authorities</li>
          <li style={{ marginBottom: '10px' }}><strong>Civil Liability:</strong> You may be held financially responsible for damages caused by your violations</li>
        </ol>
        <p style={{ marginTop: '15px' }}>We reserve the right to take immediate action without prior notice for serious violations, including but not limited to illegal activities, security threats, or uploading of prohibited content.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>User Responsibilities</h2>
        <p>As a user of SmartPDF Tools, you are responsible for:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}>Ensuring you have the legal right to upload and process all files</li>
          <li style={{ marginBottom: '10px' }}>Complying with all applicable laws and regulations in your jurisdiction</li>
          <li style={{ marginBottom: '10px' }}>Maintaining the security and confidentiality of your account credentials</li>
          <li style={{ marginBottom: '10px' }}>Monitoring activity on your account and reporting any unauthorized use</li>
          <li style={{ marginBottom: '10px' }}>Using the Service in a manner that does not interfere with other users' access</li>
          <li style={{ marginBottom: '10px' }}>Regularly reviewing this AUP for updates and changes</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Cooperation with Law Enforcement</h2>
        <p>We cooperate fully with law enforcement agencies and may disclose user information, uploaded content, or usage patterns when:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}>Required by law or legal process</li>
          <li style={{ marginBottom: '10px' }}>Necessary to protect our rights, property, or safety</li>
          <li style={{ marginBottom: '10px' }}>Needed to prevent fraud, abuse, or illegal activity</li>
          <li style={{ marginBottom: '10px' }}>In response to valid law enforcement requests</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Monitoring and Content Review</h2>
        <p>While we respect user privacy, we reserve the right to:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li style={{ marginBottom: '10px' }}>Monitor usage patterns to detect abuse or violations of this AUP</li>
          <li style={{ marginBottom: '10px' }}>Review content when violations are suspected or reported</li>
          <li style={{ marginBottom: '10px' }}>Use automated systems to detect prohibited content</li>
          <li style={{ marginBottom: '10px' }}>Investigate accounts that exhibit suspicious activity</li>
        </ul>
        <p style={{ marginTop: '15px' }}>We do not routinely review user files but may do so when necessary to enforce this policy or comply with legal obligations.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Changes to This Policy</h2>
        <p>We reserve the right to modify this Acceptable Use Policy at any time. Changes will be effective immediately upon posting to our website. Continued use of the Service after changes constitutes acceptance of the updated AUP.</p>
        <p style={{ marginTop: '15px' }}>We encourage you to review this policy periodically to stay informed of any updates.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Contact Information</h2>
        <p>If you have questions about this Acceptable Use Policy or wish to report violations, please contact us:</p>
        <div style={{ background: '#f3f4f6', padding: '15px', borderRadius: '8px', marginTop: '15px' }}>
          <p style={{ margin: '5px 0' }}><strong>General Inquiries:</strong> <a href="mailto:support@smrtpdftools.com" style={{ color: "#2563eb" }}>support@smrtpdftools.com</a></p>
          <p style={{ margin: '5px 0' }}><strong>Abuse Reports:</strong> <a href="mailto:support@smrtpdftools.com" style={{ color: "#2563eb" }}>support@smrtpdftools.com</a></p>
          <p style={{ margin: '5px 0' }}><strong>Legal Matters:</strong> <a href="mailto:support@smrtpdftools.com" style={{ color: "#2563eb" }}>support@smrtpdftools.com</a></p>
          <p style={{ margin: '5px 0' }}><strong>Website:</strong> smrtpdftools.com</p>
        </div>
      </section>

      <div style={{ marginTop: '40px', padding: '20px', background: '#fef2f2', borderLeft: '4px solid #ef4444', borderRadius: '4px' }}>
        <p style={{ margin: 0, fontSize: '0.95rem', color: '#991b1b' }}>
          <strong>Important Notice:</strong> Violation of this Acceptable Use Policy may result in immediate account suspension or termination without refund. We reserve all rights to pursue legal action for serious violations. By using SmartPDF Tools, you agree to abide by this policy.
        </p>
      </div>
    </div>
    </div>
  );
};

export default AcceptableUsePolicy;